import { atom } from "jotai";

export const isPaywallOpenAtom = atom<boolean>(false);
export const isSoftPaywallAtom = atom<boolean>(true);
